import MessageApi from '../../../../api/inbox/message';

export default {
  async transcribeMedia(_, { conversationId, messageId }) {
    await MessageApi.transcribeMedia(conversationId, messageId);
  },
};
